'use client';

import type { ButtonHTMLAttributes} from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

export const IconButtonBase = styled.button<{ $touchTargetInset?: number }>`
  position: relative;
  display: inherit;
  border-radius: 18.7px;
  border: none;
  background-color: transparent;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  padding: 0;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  z-index: 1;

  ${({ $touchTargetInset }) =>
    $touchTargetInset &&
    css`
      &::before {
        content: '';
        position: absolute;
        inset: ${$touchTargetInset * -1}px;
        z-index: -1;
      }
    `}
`;

type ButtonProps = {
  touchTargetInset?: number;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const IconButton = forwardRef((props: ButtonProps, ref: any) => {
  const { children, touchTargetInset, ...rest } = props;

  return (
    <IconButtonBase $touchTargetInset={touchTargetInset} ref={ref} type="button" {...rest}>
      {children}
    </IconButtonBase>
  );
});
